import { call, put, takeLatest } from 'redux-saga/effects';

import { adminUsers, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';

export function* get() {
  try {
    const response = yield call(dataProvider.getList, 'Users/Admins', {});

    yield put({
      type: adminUsers.get.end,
      payload: response.data,
    });
  } catch (e) {
    yield put({ type: adminUsers.get.error, payload: e.message });
    yield put({ type: notification.add, payload: { error: e.message } });
  }
}

export default function* getAdminUsers() {
  yield takeLatest(adminUsers.get.start, get);
}
